import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-header',
  templateUrl: './terms-header.component.html',
  styleUrls: ['./terms-header.component.css']
})
export class TermsHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
